import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSpecialPricingRuleQuery } from 'api';

export const useSpecialPricingRules = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const [specialPricingRuleId, setSpecialPricingRuleId] = useState<string | undefined>(undefined);
  const { id } = useParams() as { id: string };
  const { data: pricingRules = [] } = useSpecialPricingRuleQuery({ id });

  const onAddModalStateChange = useCallback(() => setAddModalState((prevState) => !prevState), []);

  const onDeleteModalOpen = useCallback((id: string) => {
    setSpecialPricingRuleId(id);
  }, []);

  const onDeleteModalClose = useCallback(() => {
    setSpecialPricingRuleId(undefined);
  }, []);
  return {
    pricingRules,
    onAddModalStateChange,
    addModalState,
    specialPricingRuleId,
    onDeleteModalOpen,
    onDeleteModalClose,
  };
};
